import { CandidateLayout } from "@/components/candidate/CandidateLayout";
import { AchievementsGrid } from "@/components/achievements/AchievementsGrid";
import { usePageMeta } from "@/hooks/usePageMeta";
import { Trophy } from "lucide-react";

export default function Achievements() {
  usePageMeta({
    title: "Minhas Conquistas - Data Hire Club",
    description: "Acompanhe suas conquistas e progresso na plataforma",
    noindex: true,
  });

  return (
    <CandidateLayout maxWidth="7xl">
      <div className="space-y-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="flex items-center justify-center w-12 h-12 rounded-full bg-primary/10">
            <Trophy className="h-6 w-6 text-primary" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold">Conquistas</h1>
            <p className="text-muted-foreground">
              Desbloqueie conquistas e ganhe pontos ao usar a plataforma
            </p>
          </div>
        </div>

        <AchievementsGrid />
      </div>
    </CandidateLayout>
  );
}
